<template>
  <div class="h-[100vh]">
    <div class="w-full flex justify-center">
      <div class="w-full mx-3">
        <FormBase />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import FormBase from "./FormBase.vue";

onMounted(() => {});
</script>
